import React from 'react'

interface PdfViewerProps {
  documentUrl?: string
  width?: string
  height?: string
}

const PdfViewer = (props: PdfViewerProps) => {
  // For now, we'll show a placeholder. Later this can be replaced with actual PDF URLs
  const defaultPdfUrl = 'https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf'
  const basePdfUrl = props.documentUrl || defaultPdfUrl
  
  // Add PDF.js parameters for fit to page and other display options
  const pdfUrl = `${basePdfUrl}#zoom=page-fit&pagemode=none&scrollbar=1&toolbar=1&navpanes=0`

  return (
    <div 
      style={{ 
        width: props.width || '100%', 
        height: props.height || '80vh',
        border: '1px solid #ddd',
        borderRadius: '4px',
        overflow: 'hidden'
      }}
    >
      <iframe
        src={pdfUrl}
        width="100%"
        height="100%"
        title="PDF Viewer"
        style={{ 
          border: 'none',
          display: 'block'
        }}
      >
        <p>Your browser does not support iframes. 
           <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
             Click here to view the PDF
           </a>
        </p>
      </iframe>
    </div>
  )
}

export default PdfViewer